// Interfaces
import { IBaseRawHtmlProps } from './interfaces'

// DOM Purify
import domPurify from 'dompurify'

const BaseRawHtml = ({ html }: IBaseRawHtmlProps) => {
  const cleanHtml = domPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  })

  return <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />
}

export { BaseRawHtml }
